module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp1_3.2a1b2cc3.png";